// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import {Checkbox} from 'cap-it-ui.toggles';
import {translate} from '../../services/translation-service';

function handleItemChange() {

    this.onChange(!this.isSelected, this.id, this.label);

}

const CheckboxItem = props => {

    const sanitizedLabel = props.isLabelTranslated ?
        props.label :
        translate(props.label);

    return (
        <li className='checkbox-item'>
            <Checkbox
                id={props.id}
                onChange={props::handleItemChange}
                selected={props.isSelected}
            >
                {sanitizedLabel}
            </Checkbox>
        </li>
    );

};

CheckboxItem.displayName = 'CheckboxItem';
CheckboxItem.propTypes = {
    id: PropTypes.string.isRequired,
    isLabelTranslated: PropTypes.bool.isRequired,
    isSelected: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired
};

export default CheckboxItem;



// WEBPACK FOOTER //
// ./src/shared/components/checkbox-list-with-label/checkbox-item.js